import { render } from "./UserUpIcon.vue?vue&type=template&id=2c0e370e"
import script from "./UserUpIcon.vue?vue&type=script&lang=js"
export * from "./UserUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__